export class Move {
  public readonly shapeNum: number;
  public readonly cellId: string;

  constructor(shapeNum: number, cellId: string) {
    this.shapeNum = shapeNum;
    this.cellId = cellId;
  }

  public serializeToString(): string {
    return `place ${this.shapeNum} ${this.cellId}`;
  }

  public static stringToMove(move: string): Move {
    const args = move.split(' ');

    function getArg(index: number): string {
      if (index < args.length) {
        return args[index];
      }
      throw new Error(`Could not find argument with index: ${index} for move: ${move}`);
    }

    const command = getArg(0);

    switch (command) {
      case 'place':
        return new Move(Number(getArg(1)), getArg(2));
      default:
        throw new Error(`Invalid move command: ${command}`);
    }
  }
}
